// EventCardSkeleton.js
import { Box, Flex, Skeleton, SkeletonText } from '@chakra-ui/react';

/**
 * Placeholder dell'EventCard: stessa struttura (immagine 16:10, corpo, footer)
 * per evitare layout shift.
 */
const EventCardSkeleton = ({ withMargin, index }) => (
  <Box
    bg="#1e2127"
    border="1px solid"
    borderColor="rgba(255,255,255,0.08)"
    borderRadius="14px"
    overflow="hidden"
    w="100%"
    minW={0}
    flex={1}
    mr={withMargin ? 4 : 0}
  >
    <Skeleton
      sx={{ aspectRatio: '16 / 10' }}
      w="100%"
      speed={index}
      startColor="#252930"
      endColor="#2f343c"
    />
    <Box p={6} pb={4}>
      <Skeleton
        h="12px"
        w="90px"
        mb={3}
        speed={index}
        startColor="#252930"
        endColor="#2f343c"
      />
      <SkeletonText
        noOfLines={2}
        spacing="3"
        speed={index}
        startColor="#252930"
        endColor="#2f343c"
      />
    </Box>
    <Flex
      px={6}
      py={4}
      justify="space-between"
      borderTop="1px solid"
      borderColor="rgba(255,255,255,0.08)"
    >
      <Skeleton
        h="20px"
        w="60px"
        speed={index}
        startColor="#252930"
        endColor="#2f343c"
      />
      <Skeleton
        h="20px"
        w="80px"
        speed={index}
        startColor="#252930"
        endColor="#2f343c"
      />
    </Flex>
  </Box>
);

export default EventCardSkeleton;
